var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.51 1.43L15.405.68c-1.632-1.112-3.977-.829-5.227.63L.54 12.56a.506.506 0 00-.123.298L0 19.433a.52.52 0 00.249.467.64.64 0 00.57.06l6.559-2.421a.593.593 0 00.245-.168l9.59-11.17c.619-.72.886-1.615.752-2.518-.133-.903-.65-1.703-1.457-2.252zM1.54 13.955l4.38 2.963-4.677 1.727.298-4.69zm5.48 2.365l-5.188-3.51 7.827-9.136 5.176 3.545-7.814 9.101zm9.253-10.775l-.709.825-5.177-3.545.734-.857c.853-.997 2.454-1.19 3.568-.431l1.103.752c.55.374.903.92.994 1.537a2.132 2.132 0 01-.513 1.719z",
    fill: "#737B7D"
  })));
}

export default SvgEditIcon;